// extracted by mini-css-extract-plugin
export var menuIcon = "_rq-0";
export var menuIconInline = "_rq-1";